import { HttpMethod, HttpOption } from '@/utils/http-client'
import {
    RepaymentPageRequest,
    PartRepaymentRequest,
    LoanRepaymentRequest,
    RepaymentDetailRequest,
    RepaymentRequest,
    PenaltyFineRequest,
    CalculationExtendsRequest,
    LoanRepaymentSubstractRequest,
    CalculationToFactTimeParams,
    UpdateRepaymentDetailRemarkRequest,
    VietRepaymentRequest,
    TallyBillApproveRecordRequest,
    TallyBillApproveRecord,
    PayRequestRecordRequest
} from '@/api/model/repayment'

export class RepaymentAPIConstant {
    repaymentPage = (data: RepaymentPageRequest): HttpOption => ({
        url: '/fundcloud/loanRepayment/selectUnrepaidRepaymentPage',
        method: HttpMethod.POST,
        data
    })

    repaymentList = (params: RepaymentRequest): HttpOption => ({
        url: '/fundcloud/loanRepayment/selectRepaymentManage',
        method: HttpMethod.GET,
        params
    })

    partRepaymentLoadData = (params: PartRepaymentRequest): HttpOption => ({
        url: '/fundcloud/loanRepayment/partRepaymentLoadData',
        method: HttpMethod.GET,
        params
    })

    loanRepaymentToWriteOff = (data: LoanRepaymentRequest): HttpOption => ({
        url: '/fundcloud/loanRepayment/loanRepaymentToWriteOff',
        method: HttpMethod.POST,
        data
    })

    loanRepaymentToPart = (data: LoanRepaymentRequest): HttpOption => ({
        url: '/fundcloud/loanRepayment/loanRepaymentToPart',
        method: HttpMethod.POST,
        data
    })

    calcPartRepayment = (data: LoanRepaymentRequest): HttpOption => ({
        url: '/fundcloud/loanRepayment/calcPartRepayment',
        method: HttpMethod.POST,
        data
    })
    calcDaysRepayment = (data: LoanRepaymentRequest): HttpOption => ({
        url: '/fundcloud/loanRepayment/calcOverdueDaysRepayment',
        method: HttpMethod.POST,
        data
    })

    queryRepaymentDetail = (data: RepaymentDetailRequest): HttpOption => ({
        url: '/fundcloud/loanRepayment/queryRepaymentDetail',
        method: HttpMethod.POST,
        data
    })

    penaltyFinePage = (data: PenaltyFineRequest): HttpOption => ({
        url: '/fundcloud/loanRepayment/selectPenaltyFinePage',
        method: HttpMethod.POST,
        data
    })

    tallyBillAproveRecordPage = (data: TallyBillApproveRecordRequest): HttpOption => ({
        url: '/fundcloud/tallyBillApprove/queryTallyBillApprovePage',
        method: HttpMethod.POST,
        data
    })

    payRequestRecordPage = (data: PayRequestRecordRequest): HttpOption => ({
        url: '/fundcloud/payRequestRecord/queryPayRequestRecordPage',
        method: HttpMethod.POST,
        data
    })

    uploadMutileFile = (data?: any): HttpOption => ({
        url: '/fundcloud/payRequestRecord/uploadStpMutileFile',
        method: HttpMethod.POST,
        data
    })
    cancelTallyBill = (data: TallyBillApproveRecord): HttpOption => ({
        url: '/fundcloud/tallyBillApprove/cancelApprove',
        method: HttpMethod.POST,
        data
    })

    repaymentInfo = (params: { lid: number; index?: number }): HttpOption => ({
        url: '/fundcloud/loanRepayment/selectRepaymentInfoByIndex',
        method: HttpMethod.GET,
        params
    })

    pauseCollection = (data: { mid: number; cameraId: number, remark: string }): HttpOption => ({
        url: '/fundcloud/loanRepayment/pause',
        method: HttpMethod.POST,
        data
    })

    resumeCollection = (data: { mid: number; cameraId: number, remark: string }): HttpOption => ({
        url: '/fundcloud/loanRepayment/release',
        method: HttpMethod.POST,
        data
    })

    submitRepaymentSubstract = (data: LoanRepaymentSubstractRequest): HttpOption => ({
        url: '/fundcloud/loanRepayment/submitRepaymentSubstract',
        method: HttpMethod.POST,
        data
    })

    queryRepaymentSubstract = (params: { lid: number; index?: number }): HttpOption => ({
        url: '/fundcloud/loanRepayment/queryRepaymentSubstract',
        method: HttpMethod.GET,
        params
    })

    calculationToFactTime = (data: CalculationToFactTimeParams): HttpOption => ({
        url: '/fundcloud/loanRepayment/calculationToFactTime',
        method: HttpMethod.POST,
        data
    })

    loanRepaymentToFactTime = (data: LoanRepaymentRequest): HttpOption => ({
        url: '/fundcloud/loanRepayment/loanRepaymentToFactTime',
        method: HttpMethod.POST,
        data
    })

    vietRepayment = (data: VietRepaymentRequest): HttpOption => ({
        url: '/fundcloud/loanRepayment/loanRepaymentMergeVi',
        method: HttpMethod.POST,
        data
    })

    calculationExtends = (data: CalculationExtendsRequest): HttpOption => ({
        url: '/fundcloud/loanRepayment/calculationExtends',
        method: HttpMethod.POST,
        data
    })

    repaymentExtends = (data: CalculationExtendsRequest): HttpOption => ({
        url: '/fundcloud/loanRepayment/repaymentExtends',
        method: HttpMethod.POST,
        data
    })

    updateRepaymentDetailRemark = (data: UpdateRepaymentDetailRemarkRequest): HttpOption => ({
        url: '/fundcloud/loanRepaymentDetail/updateRemark',
        method: HttpMethod.POST,
        data
    })
}
